module.exports = {
  Guide: require('./base'),
  Arc: require('./arc'),
  DataMarker: require('./data-marker'),
  DataRegion: require('./data-region'),
  Html: require('./html'),
  Image: require('./image'),
  Line: require('./line'),
  Region: require('./region'),
  Text: require('./text')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_component@0.3.8@@antv/component/lib/guide/index.js
// module id = 324
// module chunks = 0 1 2